import Container from '@amzn/awsui-components-react/polaris/container';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import {
  AmbassadorRegistrationForm,
  AmbassadorRegistrationFormValues,
} from '../components/ambassadors/ambassadorRegistrationForm';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { COMMUNITY_AMBASSADOR_FEATURE_FLAG } from '../utils/constants';
import { useState } from 'react';
import { useCreateAmbassador } from '../hooks/ambassadors/ambassadorCreation/createAmbassadorMutation';
import { IneligibilityReasons } from '@amzn/red-velvet-api';
import {
  AmbassadorRegistrationFailure,
  AmbassadorRegistrationSuccess,
} from '../components/ambassadors/ambassadorRegistrationResults';
import { getAuthAlias } from '../utils/auth';
import { ambassadorFormValuesToRequest } from '../utils/ambassadors';

export function AmbassadorRegistration() {
  const [searchParams] = useSearchParams();
  const features = useFeatures();

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [successfulRegistration, setSuccessfulRegistration] = useState(false);
  const [ineligibilityReasons, setIneligibilityReasons] = useState<
    IneligibilityReasons | undefined
  >();

  const [formValues, setFormValues] = useState<AmbassadorRegistrationFormValues>({
    language: null,
    country: null,
    city: null,
    siteType: null,
    siteCode: null,
    businessUnit: null,
    siteRepresentation: false,
    teamRepresentation: false,
    employeeLedGroupRepresentation: false,
    howDidYouHearSpecification: '',
    howDidYouHear: null,
    myManagerHasApprovedThisRole: false,
    sendMeACopy: false,
  });

  const { t } = useTranslation();
  const createAmbassador = useCreateAmbassador();

  const getActiveUserAlias = (): string | undefined => {
    return getAuthAlias() ?? undefined;
  };

  const submitRegistration = async () => {
    createAmbassador.mutate(ambassadorFormValuesToRequest(formValues, getActiveUserAlias(), t), {
      onSuccess: (data) => {
        setHasSubmitted(true);
        setSuccessfulRegistration(data.result.isSuccess);
        if (data.result.ineligibilityReasons) {
          setIneligibilityReasons(data.result.ineligibilityReasons);
        }
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  if (featureIsEnabled(COMMUNITY_AMBASSADOR_FEATURE_FLAG, features, searchParams)) {
    return (
      <Container fitHeight variant="stacked">
        {!hasSubmitted ? (
          <>
            <h1>{t('ambassadorRegistration.title')}</h1>
            <AmbassadorRegistrationForm
              formValues={formValues}
              setFormValues={setFormValues}
              onSubmit={submitRegistration}
              loading={createAmbassador.isPending}
            />
          </>
        ) : (
          <>
            {successfulRegistration ? (
              <AmbassadorRegistrationSuccess />
            ) : (
              <AmbassadorRegistrationFailure ineligibilityReasons={ineligibilityReasons} />
            )}
          </>
        )}
      </Container>
    );
  }
  return <></>;
}
